/** @format */

import React from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";

const LineGraph = () => {
  const graphData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Total",
        data: [10, 24, 56, 68, 90, 90],
        borderColor: "#4C4DDC",
        borderWidth: 1,
        backgroundColor: "#4C4DDC",
        fill: false,
      },
      {
        label: "Lost",
        data: [10, 40, 47, 90, 34, 60],
        borderColor: "#CB3A31",
        backgroundColor: "#CB3A31",
        borderWidth: 1,
        fill: false,
      },
      {
        label: "Doubtful",
        data: [10, 34, 50, 67, 65, 70],
        borderColor: "#CD7B2E",
        backgroundColor: "#CD7B2E",
        borderWidth: 1,
        fill: false,
      },
      {
        label: "Recovered",
        data: [10, 40, 20, 70, 50, 40],
        borderColor: "#43936C",
        backgroundColor: "#43936C",
        borderWidth: 1,
        fill: false,
      },
    ],
  };

 const options = {
   scales: {
     x: {
       grid: {
         display: true,
         color: "#F5F5FF",
         drawBorder: false,
       },
       ticks: {
         display: false,
       },
     },
     y: {
       grid: {
         display: true,
         color: "#F5F5FF",
         drawBorder: false,
       },
       ticks: {
         display: false,
         stepSize: 10,
       },
     },
   },
   plugins: {
     legend: {
       align: "start",

       fullSize: true,
       display: true,
       labels: {
         usePointStyle: true,
         pointStyle: "circle",
         boxWidth: 6,
         boxHeight: 6,
       },
     },
   },
   elements: {
     point: {
       radius: 0.5,
       borderWidth: 1,
       backgroundColor: "#F5F5FF",
       borderColor: "#F5F5FF",
     },
   },
   layout: {
     padding: {
       top: 20,
       left: 15,
       right: 15,
       bottom: 15,
     },
   },
 };


  const legendPaddingPlugin = {
    id: "custom_legend_padding",
    afterInit: function (chart, args, options) {
      const leftPadding = 90; // adjust to move legend to the right
      chart.legend.left += leftPadding;
      chart.legend.right += leftPadding;
      chart.legend.width -= leftPadding;
    },
  };

  Chart.register(legendPaddingPlugin);

  return <Line data={graphData} options={options} />;
};

export default LineGraph;
